// Illustration de la page d'accueil : « du terrain à l'insight ».
//
// À gauche, ce que l'on recueille — des verbatims, avec leur locuteur et leurs
// tags colorés. À droite, ce que l'on en tire — un insight et ses mesures. Entre
// les deux, les liens de preuve. C'est le produit, dessiné.
//
// Tracée au trait comme les pictogrammes (1,5 px, coins ronds), sans dégradé ni
// ombre. Les couleurs sont celles des catégories (`--hue-*`) : l'illustration
// suit donc le thème clair ou sombre sans variante à maintenir. Purement
// décorative — `aria-hidden`.
export function ResearchIllustration() {
  return (
    <svg className="illu" viewBox="0 0 420 240" fill="none" aria-hidden="true">
      {/* — Le terrain : trois verbatims — */}
      <rect className="i-card" x="14" y="24" width="158" height="68" rx="12" />
      <circle className="i-tint hue-orange" cx="38" cy="48" r="11" />
      <path className="i-line" d="M58 44h92" />
      <path className="i-line" d="M58 56h62" />
      <rect className="i-tint hue-orange" x="28" y="69" width="46" height="13" rx="6.5" />
      <rect className="i-tint hue-green" x="80" y="69" width="34" height="13" rx="6.5" />

      <rect className="i-card" x="38" y="106" width="158" height="68" rx="12" />
      <circle className="i-tint hue-pink" cx="62" cy="130" r="11" />
      <path className="i-line" d="M82 126h96" />
      <path className="i-line" d="M82 138h54" />
      <rect className="i-tint hue-violet" x="52" y="151" width="40" height="13" rx="6.5" />
      <rect className="i-tint hue-blue" x="98" y="151" width="52" height="13" rx="6.5" />

      <rect className="i-card" x="20" y="188" width="140" height="38" rx="12" />
      <circle className="i-tint hue-blue" cx="42" cy="207" r="9" />
      <path className="i-line" d="M60 207h78" />

      {/* — Les liens de preuve — */}
      <path className="i-flow" d="M172 58C214 58 212 100 252 104" />
      <path className="i-flow" d="M196 140C224 140 226 122 252 120" />
      <path className="i-flow" d="M160 207C216 207 214 140 252 136" />

      {/* — L'insight, et ce qu'il mesure — */}
      <rect className="i-card i-card-accent" x="252" y="42" width="154" height="152" rx="14" />
      <rect className="i-tint hue-amber" x="268" y="58" width="34" height="34" rx="9" />
      <g className="i-stroke hue-amber" transform="translate(273 63)">
        <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
        <path d="M9 18h6" />
        <path d="M10 22h4" />
      </g>
      <path className="i-line" d="M314 68h74" />
      <path className="i-line" d="M314 82h44" />
      <rect className="i-fill hue-cyan" x="270" y="142" width="16" height="36" rx="4" />
      <rect className="i-fill hue-violet" x="294" y="124" width="16" height="54" rx="4" />
      <rect className="i-fill hue-green" x="318" y="152" width="16" height="26" rx="4" />
      <rect className="i-fill hue-orange" x="342" y="134" width="16" height="44" rx="4" />
      <rect className="i-fill hue-pink" x="366" y="114" width="16" height="64" rx="4" />

      {/* — Quelques étincelles — */}
      <path className="i-stroke hue-amber" d="M392 12v12M386 18h12" />
      <path className="i-stroke hue-cyan" d="M222 22v8M218 26h8" />
      <circle className="i-stroke hue-pink" cx="232" cy="212" r="5" />
      <circle className="i-stroke hue-green" cx="404" cy="220" r="3.5" />
    </svg>
  );
}
